import { Divider, MenuItem } from "@mui/material";
import Menu from "../../menu/menu";
import Typography from "../../typography/typography";
import { useEffect, useState } from "react";
import AddPageModal from "./add-page-modal";
import { IPage } from "../../../@types/page";
import SharePopUp from "../../share-modal/share-modal";
import { userRoles } from "../../../views/beforeAuth/components/share-modal-data/share-modal-data";
import ConfirmPopUp from "../../confirm-modal/confirm-modal";
import { useSelector, useDispatch } from "react-redux";
import { pinToDashboardList } from "../../../views/afterAuth/dashboard/redux/reducer";
import {
  // deleteV1DashboardId,
  // putV1DashboardId,
} from "../../../api-client/api.system-feature/api";
// import type * as Types from "../../api-client/api.system-feature/api-types";
import { sharePage } from "../../share-modal/redux/actionCreator";
import { useAppDispatch } from "../../../redux/hooks";
import { generateRandomId } from "../../../utils/common";
import { usePages } from '@erpsquad/common/runtime';

interface IPageAction {
  open: null | HTMLElement;
  onClose: () => void;
  page?: IPage;
  pages: IPage[];
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setPages: React.Dispatch<React.SetStateAction<IPage[]>>;
  resource: string;
  handlePageDelete: (pages: any[]) => void;
}

const moveLeft = (arr: IPage[], pageValue: number) => {
  const updatedArray = [...arr];
  if (updatedArray.length <= 1) return;

  const index = updatedArray.findIndex((item) => item._id === pageValue);

  if (index === 0) return;

  const elementToShift = updatedArray.splice(index, 1)[0];
  updatedArray.splice(index - 1, 0, elementToShift);
  return updatedArray;
};

const moveRight = (arr: IPage[], pageValue: number) => {
  const updatedArray = [...arr];
  if (updatedArray.length <= 1) return;

  const index = updatedArray.findIndex((item) => item._id === pageValue);

  if (index === updatedArray.length - 1) return;

  const elementToShift = updatedArray.splice(index, 1)[0];
  updatedArray.splice(index + 1, 0, elementToShift);
  return updatedArray;
};

const deletePage = (arr: IPage[], pageValue: number) => {
  const updatedArray = [...arr];
  if (updatedArray.length <= 1) return;

  const index = updatedArray.findIndex((item) => item._id === pageValue);

  updatedArray.splice(index, 1);
  return updatedArray;
};

const PageAction = ({
  open,
  onClose,
  page,
  pages,
  setCurrentPage,
  setPages,
  resource,
  handlePageDelete,
}: IPageAction) => {
  
  const [isEditPageModalOpen, setIsEditPageModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [deletePageNo, setDeletePageNo] = useState<any>({});
  const [defaultSharedData, setDefaultSharedData] = useState<any>({});
  const [pageSharedData, setPageSharedData] = useState<any>([]);
  const pinToDashboardStore = useSelector((state: any) => state);
  const [pinToDashboardData, setPinToDashboardData] = useState<any>(
    pinToDashboardStore?.dashboard?.pinToDashboardList || [],
  );


  const appDispatch = useAppDispatch();
  const dispatch = useDispatch();
  const {setIsCreatePage}=usePages()
  // const token = zI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6OSwiaWF0IjoxNzA2NDcwNzQwfQ.6dtxBVGl4hF0TrNDanSBTiFtV_TUshjaiaYe9XT2Ld8";
  useEffect(() => {
    dispatch(pinToDashboardList(pinToDashboardData));
  }, [dispatch, pageSharedData, pinToDashboardData]);

  useEffect(()=>{
  
   if(page){
    setPageSharedData([...pageSharedData,{
        page:{
          ...page,
          value:page?._id
        },
       isPublic: true,
       shareUsers:page?.selectedUsers,
    }])
   }
   //eslint-disable-next-line
  },[page])
  

  const handleOpenEditModal = () => {
    onClose();
    setIsEditPageModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditPageModalOpen(false);
  };

  const handleShare = (pageData: any) => {
    pageData.pages = pages;
    appDispatch(sharePage(pageData)).then((res) => {
      if (res?.payload?.data?.pages?.length) {
        setPages(res?.payload?.data?.pages);
      }
      setIsShareModalOpen(false);
    });
  };

  const handleSharePage = (page: any) => {
    const defaultData = pageSharedData.find(
      (item: any) => item.page?.value === page?.value,
    );
    if (defaultData) {
      setDefaultSharedData({
        isPublic: defaultData.isPublic,
        selectedUsers: defaultData.shareUsers,
      
      });
    } else {
      setDefaultSharedData({
        isPublic: page?.selectedUsers?.length>0,
        ...page,
      });
    }
    setIsShareModalOpen(true);
    setIsShareModalOpen(true);
  };

  const handleDuplicatePage = (page: any) => {
    const labelExists = (label: string) =>
      pages.some((item) => item.name === label);
    const { uniqueNumberId: _id } = generateRandomId();
    let newLabel = page.name;

    if (labelExists(newLabel)) {
      let counter = 1;
      while (labelExists(`${page.name} ${counter}`)) {
        counter++;
      }
      newLabel = `${page.name} ${counter}`;
    }
    const updatedPage = [
      ...pages,
      { ...page, name: newLabel, _id, data: page.data, isShared: false },
    ];

    setPages(updatedPage);
    setIsCreatePage(true)
  };

  const handleEdit = (newPage: IPage) => {
    const updatedPages = pages.map((page) => {
      if (page._id === newPage._id) {
        return {
          ...page,
          name: newPage.name
        }
      }
      return page
    })

    setPages(updatedPages);
    setIsCreatePage(true)
    // const putDashboardRequest: Types.PutV1DashboardIdRequest = {
    //   "x-token": token,
    //   module: "user",
    //   user_id: "1",
    //   name: newPage.name,
    //   id: newPage._id,
    // };
    // putV1DashboardId(putDashboardRequest)
    //   .then((response: any) => {
    //     const prevPages = [...pages];
    //     const updatedPages = prevPages.map((page) =>
    //       page._id === newPage._id ? newPage : page,
    //     );
    //     setPages(updatedPages);
    //     updatePinToDashboardPage(updatedPages);
    //   })
    //   .catch((err: any) => console.log("Error in adding page", err));
  };

  // const updatePinToDashboardPage = (updatedPages: any) => {
  //   const currentPageLabel = updatedPages.find(
  //     (item: any) => item.value === page?._id,
  //   )?.label;

  //   const updatedPinToDashboardData = pinToDashboardData.map((data: any) => ({
  //     ...data,
  //     label: data.value === page?._id ? currentPageLabel : data.label,
  //   }));

  //   setPinToDashboardData(updatedPinToDashboardData);
  // };

  const handleMoveLeft = (pageValue: any) => {
    const updatedArray = moveLeft(pages, pageValue?._id);
    if (updatedArray) setPages(updatedArray);
  };

  const handleMoveRight = (pageValue: any) => {
    const updatedArray = moveRight(pages, pageValue?._id);
    if (updatedArray) setPages(updatedArray);
  };

  const handleDeletePage = (pageValue: any) => {
    setIsConfirmOpen(true);
    setDeletePageNo(pageValue);
  };

  const handleConfirmDelete = () => {
    // if (!isNaN(deletePageNo._id)) {
    // const deleteDashboardRequest: Types.DeleteV1DashboardIdRequest = {
    //   "x-token": token,
    //   id: deletePageNo._id,
    // };
    // deleteV1DashboardId(deleteDashboardRequest)
    //   .then((response: any) => {
    //   })
    //   .catch((err: any) => console.log("Error in deleting page", err));
    // }
    
    const updatedArray = deletePage(pages, deletePageNo?._id);
    deletePinToDashboardPage();
    setDeletePageNo({});
    setIsConfirmOpen(false);
    if (updatedArray) {
      setCurrentPage(updatedArray[0]);
      setPages(updatedArray);
      handlePageDelete(updatedArray);
    } else {
      handlePageDelete([]);
      setPages([]);
    }
  };

  const deletePinToDashboardPage = () => {
    const updatedPinToDashboardData = pinToDashboardData.filter(
      (data: any) => data.value !== page?._id,
    );
    setPinToDashboardData(updatedPinToDashboardData);
  };

  const handleShareModal = (selectedUsers: any) => {

    let updatedData: any[] = [];
    const existingItem = pageSharedData.find(
      (item: any) => item.page.value === page?._id,
    );

    if (existingItem) {
      updatedData = pageSharedData.map((item: any) => {
        if (item.page.value === page?._id) {
          return {
            ...item,
            isPublic: selectedUsers.isPublic,
            shareUsers: selectedUsers.selectedUsers,
          };
        }
        return item;
      });
    } else {
      updatedData = [
        ...pageSharedData,
        {
          page: page,
          isPublic: selectedUsers.isPublic,
          shareUsers: selectedUsers.selectedUsers,
          viewStyle: 1,
          owner: 0,
        },
      ];
    }
    setPageSharedData(updatedData);
    handleShare({ ...selectedUsers, page: page, resource });
  };

  const handlePinToDashboard = () => {
    const index = pinToDashboardData.findIndex(
      (item: any) => item.value === page?._id,
    );

    if (index !== -1) {
      setPinToDashboardData((prevData: any) => {
        const updatedData = [...prevData];
        updatedData[index] = { ...updatedData[index], label: page?.name };
        return updatedData;
      });
    } else {
      setPinToDashboardData((prevData: any) => [...prevData, page]);
    }
  };

  const actions = [
    {
      label: "Rename",
      func: handleOpenEditModal,
      disabled: Boolean(page?.isShared)
    },
    {
      label: "Duplicate",
      func: handleDuplicatePage,
    },
    {
      label: "Share",
      func: handleSharePage,
      disabled: Boolean(page?.isShared)
    },
    {
      label: "Pin to dashboard",
      func: handlePinToDashboard,
      disabled: Boolean(page?.isShared)
    },
    {
      label: "Move Right",
      func: handleMoveRight,
      disabled: (pages?.length <= 1) || Boolean(page?.isShared)
    },
    {
      label: "Move Left",
      func: handleMoveLeft,
      disabled: (pages?.length <= 1) || Boolean(page?.isShared)
    },
  ];

  const handleAction = (func: any) => {
    func(page);
    onClose();
  };

  return (
    <>
      <Menu open={Boolean(open)} anchorEl={open} onClose={onClose}>
        {actions?.map((action) => (
          <MenuItem
            key={action?.label}
            onClick={() => handleAction(action.func)}
            disabled={Boolean(action?.disabled)}
          >
            <Typography color="theme.secondary.1000" type="s4">
              {action?.label}
            </Typography>
          </MenuItem>
        ))}
        <Divider sx={{ mt: `4px !important`, mb: `4px !important` }}/>
        <MenuItem onClick={() => handleAction(handleDeletePage)} disabled={Boolean(page?.isShared)}
          sx={{
            '&:hover': {
              backgroundColor: 'theme.error.100'
            }
          }}
        >
          <Typography color="theme.error.500" type="s4">
            Delete
          </Typography>
        </MenuItem>
      </Menu>

      <AddPageModal
        open={isEditPageModalOpen}
        page={page}
        pages={pages}
        onClose={handleCloseEditModal}
        handleSubmit={handleEdit}
      />

      <ConfirmPopUp
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Delete Confirmation?"
        description="Are you sure you want to delete this page ?"
      />
      <SharePopUp
        open={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        title={`Share page ${page?.name}`}
        roles={userRoles}
        toggleSwitch={true}
        value={defaultSharedData}
        onSubmit={handleShareModal}
      />
    </>
  );
};

export { PageAction };
export default PageAction;
